/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './enableAccountInvites.defs'
export { main as default } from './enableAccountInvites.defs'
